export default function Contact() {
  return (
    <div className="page">
      <div className="page-container">
        <header className="page-header">
          <h1 className="page-title">Contact Us</h1>
        </header>

        <div className="content-card">
          <div className="card-body">
            <p>
              For implementation enquiries, partnership discussions, or
              briefing requests, please contact ASDRY directly.
            </p>

            <h2 className="content-subtitle" style={{ marginTop: "24px" }}>
              General & Commercial Enquiries
            </h2>

            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@asdry.com" className="content-link">
                info@asdry.com
              </a>
            </p>

            <p>
              Please include a short description of your organisation,
              event type, and timeline where applicable.
            </p>

            <h2 className="content-subtitle" style={{ marginTop: "32px" }}>
              Response Time
            </h2>

            <p>
              We aim to respond within 2–3 working days.
            </p>

            <h2 className="content-subtitle" style={{ marginTop: "32px" }}>
              Company Information
            </h2>

            <p>
              <strong>Business hours:</strong> Monday–Friday, 9:00 AM – 5:00 PM (UK)
            </p>

            <p>
              <strong>Registered address:</strong>
              <br />
              ASDRY LTD
              <br />
              Unit A, 82 James Carter Road
              <br />
              Mildenhall, Suffolk
              <br />
              IP28 7DE
              <br />
              United Kingdom
            </p>

            <p>
              <strong>Company number:</strong> 15010407 (UK)
            </p>

            <hr className="content-divider" />

            <p style={{ fontStyle: "italic" }}>
              ASDRY provides structured environmental preparation briefings for
              outdoor sporting events and operational teams.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}